import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { SuperAdminService } from "src/app/super-admin.service";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { MatSort } from "@angular/material/sort";
import { NgxSpinnerService } from "ngx-spinner";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

@Component({
  selector: "app-tracker-invoice-list",
  templateUrl: "./tracker-invoice-list.component.html",
  styleUrls: ["./tracker-invoice-list.component.css"],
})
export class TrackerInvoiceListComponent implements OnInit {
  clientList: any[] = [];
  trackerNumber: any[] = [];
  invoiceType: any[] = [];
  invoiceList: any[] = [];
  dataSource: MatTableDataSource<any>;

  invtot: any;
  tooltaxPaidtot: any;
  extrahour: any;
  kmtot: any;

  users: any[] = [];
  paramId: string;

  displayedColumns = ["sno", "clientName", "created_date", "action"];

  dropdownSettings = {
    singleSelection: false,
    idField: "item_id",
    textField: "item_text",
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
  };

  filterform = new FormGroup({
    clientName: new FormControl("", Validators.required),
    invoiceType: new FormControl("", Validators.required),
    Tracker_no: new FormControl("", Validators.required),
  });

  @ViewChild("printBtn") printBtn: ElementRef<HTMLElement>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild("printSection") printSection!: ElementRef<HTMLDivElement>;
  constructor(
    private router: Router,
    private toastr: ToastrService,
    private superAdminService: SuperAdminService,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.getClientList();
    this.getInvoiceTypes();
    this.getTrackerInvoices();
  }

  private handleAuthOrError(message: string, status: number): void {
    this.spinner.hide();
    if (status === 401) {
      this.toastr.error(message);
      sessionStorage.clear();
      this.router.navigateByUrl("superAuth/login");
    } else {
      this.toastr.error(message);
    }
  }

  getTrackerInvoices() {
    this.superAdminService.getTrackerInvoiceNew().subscribe((res) => {
      if (res.status) {
        this.invoiceList = res.data;
        this.dataSource = new MatTableDataSource(this.invoiceList);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    });
  }

  onClientChange(event: any) {
    const clientId = event.target.value;
    this.superAdminService.getTrackersByClientId(clientId).subscribe((res) => {
      if (res.status) {
        this.trackerNumber = res.data.map((x, i) => ({
          item_id: i,
          item_text: x.Tracker_no,
        }));
      }
    });
  }

  generateTrackerInvoice(): void {
    if (!this.filterform.valid) {
      this.toastr.error("Please fill all required fields");
      return;
    }

    const selectedTrackers = Array.isArray(this.filterform.value.Tracker_no)
      ? this.filterform.value.Tracker_no.map((item: any) => item.item_text)
      : [];

    if (!selectedTrackers.length) {
      this.toastr.error("Please select at least one Tracker");
      return;
    }

    const payload = {
      clientId: this.filterform.value.clientName,
      invoiceType: this.filterform.value.invoiceType,
      trackerNos: selectedTrackers,
    };

    this.spinner.show();

    this.superAdminService.generateTrackerInvoice(payload).subscribe(
      (res) => {
        this.spinner.hide();
        if (res.status) {
          this.toastr.success(res.message);
          this.getTrackerInvoices();
          this.filterform.reset();
          this.trackerNumber = [];
        } else {
          this.toastr.error(res.message);
        }
      },
      () => {
        this.spinner.hide();
        this.toastr.error("Something went wrong");
      }
    );
  }

  getParticularInvoice(id: string) {
    this.paramId = id;
    this.spinner.show();

    this.superAdminService.getParticularInvoice(id).subscribe(
      (res: any) => {
        this.spinner.hide();

        if (!res.status) {
          this.toastr.error(res.message);
          return;
        }

        const invoice = res.data?.[0]?.invoice || [];
        this.users = invoice;

        if (invoice.length) {
          const value = invoice[0];

          this.invtot = value.balancePaid?.reduce((a, b) => +a + +b, 0) || 0;
          this.kmtot = value.up_down_km?.reduce((a, b) => +a + +b, 0) || 0;
          this.extrahour = value.extrahour?.reduce((a, b) => +a + +b, 0) || 0;
          this.tooltaxPaidtot =
            value.tooltaxPaid?.reduce((a, b) => +a + +b, 0) || 0;
        }

        setTimeout(() => {
          this.printBtn?.nativeElement?.click();
        }, 300);
      },
      () => {
        this.spinner.hide();
        this.toastr.error("Failed to load invoice");
      }
    );
  }

  deleteTrackerInvoice(id: string) {
    console.warn("TODO: deleteTrackerInvoice()", id);
  }

  viewTrackerInvoice(id: string): void {
    this.router.navigate(["/superAdmin/lrmanagement/tracker-invoice/view", id]);
  }

  getClientList(): void {
    this.superAdminService.getClientList().subscribe(
      (res: any) => {
        if (!res.status) {
          this.handleAuthOrError(res.message, res.status);
          return;
        }

        let clients = res.data || [];
        const userSessionData = JSON.parse(
          sessionStorage.getItem("userSession")
        );

        const userRoleId = userSessionData?.user_role_id?.[0];

        if (userRoleId !== 1 && Array.isArray(userSessionData?.clientList)) {
          clients = clients.filter((client) =>
            userSessionData.clientList.includes(client.clientEmail)
          );
        }

        this.clientList = clients;
      },
      () => this.toastr.error("Failed to load clients")
    );
  }

  getInvoiceTypes() {
    this.superAdminService.getInvoiceTypes().subscribe((res: any) => {
      if (res.status) {
        this.invoiceType = res.data;
      } else {
        this.handleAuthOrError(res.message, res.status);
      }
    });
  }

  sendInvoice(printSectionId: string, id: string) {
  this.paramId = id;
  
  // First load the invoice data (same as print)
  this.getParticularInvoice(id); // this populates users, invtot, etc.

  // After data is loaded, html2canvas will work
  setTimeout(() => {
    if (!this.printSection) {
      this.toastr.error('Invoice not loaded yet. Please try again.');
      return;
    }

    const data = this.printSection.nativeElement;

    html2canvas(data, { scale: 2 }).then(canvas => {
      // const imgWidth = 208;
      // const imgHeight = (canvas.height * imgWidth) / canvas.width;
      // const contentDataURL = canvas.toDataURL('image/png');

      const pdf = new jsPDF('p', 'mm', 'a4');
      // pdf.addImage(contentDataURL, 'PNG', 1, 1, imgWidth, imgHeight, undefined, 'FAST');
      
      const binary = btoa(pdf.output());

      this.superAdminService.sendInvoice(this.paramId, binary).subscribe((res: any) => {
        res.status 
          ? this.toastr.success(res.message) 
          : this.toastr.error(res.message);
      });
    });
  }, 800); // small delay to ensure DOM is updated
}

  backTo() {
    window.history.back();
  }

  filterData(value: string) {
    this.dataSource.filter = value.trim().toLowerCase();
  }
}
